import authenticate from '@/middleware/authenticate'
import store from '@/store'
import apiExchangeRate from '@/api/administration/exchange-rate'

export default [
  {
    path: '/exchange-rates',
    name: 'exchange-rate',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/exchange-rate/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('administration/exchangeRate/fetchCurrency').then(() => {
        next()
      })
    }
  },
  {
    path: '/exchange-rates/:id',
    name: 'exchange-rate-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/exchange-rate/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiExchangeRate.find(to.params.id)
      to.params.editData = response.data
      store.dispatch('administration/exchangeRate/fetchCurrency').then(() => {
        next()
      })
    }
  }
]
